import vacancybig from "../images/vacancybig.svg";
import vacancysmall from "../images/vacancysmall.svg";

const Loading = () => {
    return (
        <div className="loading">
            <img src={vacancysmall} className="smallloading" alt="" />
            <img src={vacancybig} className="bigloading" alt="" />
        </div>
    );
};

export default Loading;
